import { render, staticRenderFns } from "./MailTemplateEditorPopup.vue?vue&type=template&id=b6bbeddc&scoped=true"
import script from "./MailTemplateEditorPopup.vue?vue&type=script&lang=js"
export * from "./MailTemplateEditorPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bbeddc",
  null
  
)

export default component.exports